import { useSnackbar } from 'notistack';
import useSnackbarService from './use-snackbar-service-hook';

export default function SnackBar(options) {
  const { enqueueSnackbar } = useSnackbar();
  const { showMessage } = useSnackbarService();

  showMessage(enqueueSnackbar, options);
  return null;
}
